package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.active
import com.varabyte.kobweb.silk.style.selectors.focusVisible
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.*
import org.lennycodes.hldi.constants.HLDITheme

val UsefulLinkStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Block)
            .position(Position.Relative)
            .color(HLDITheme.Colors.white)
            .opacity(0.85)
            .padding(8.px, 0.px)
            .textDecorationLine(TextDecorationLine.None)

            // Smooth, modern motion
            .transition(
                Transition.all(
                    duration = 0.25.s,
                    timingFunction = TransitionTimingFunction.cubicBezier(0.4, 0.0, 0.2, 1.0)
                )
            )
    }

    hover {
        Modifier
            .fontWeight(FontWeight.ExtraBold)
            .opacity(1)
            .color(HLDITheme.Colors.accent)
            .transform { translateX(6.px) }
            .textDecorationLine(TextDecorationLine.None)
    }

    focusVisible {
        Modifier
            .opacity(1)
            .color(HLDITheme.Colors.accent)
            .outline(2.px, LineStyle.Solid, HLDITheme.Colors.accent)
            .outlineOffset(2.px)
    }

    active {
        Modifier
            .opacity(1)
            .transform { translateX(3.px) }
    }
}